/**
 * Created by Ivan on 10.08.2026
 */

const StickersCollectionIcon2 = function (collection) {
    return Prefab.instantiate(bundles.stickers2_book_window.jsons.stickers_collection_icon_prefab_json, { collection });
};
